import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "./lib/theme.tsx";
import App from "./App.tsx";
import { PwaUpdater } from "./components/PwaUpdater.tsx";
import { InstallPrompt } from "./components/InstallPrompt.tsx";
import { OfflineIndicator } from "./components/OfflineIndicator.tsx";

// Capture ?go= before any selector→tenant redirect drops it.
const go = new URLSearchParams(window.location.search).get("go");
if (go) sessionStorage.setItem("zedule-go", go);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No root element found");

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <App />
      <PwaUpdater />
      <InstallPrompt />
      <OfflineIndicator />
    </ThemeProvider>
  </StrictMode>,
);
